import BasketEventNameSFC from "./BasketEventName.vue";
export const BasketEventName = BasketEventNameSFC;
